



















export default  {
  methods: {
    logout: function () {
      this.$router.push({ name: 'logout' })
    },
    goHome: function () {
      if (this.$store.getters.authStatus) {
        this.$router.push({ name: 'overview' })
      }
     
    },
  }
}

